export default {"src":"https://search.testwiggot.com/_next/static/media/firts-time.c181afb0.svg","height":172,"width":182,"blurWidth":0,"blurHeight":0};